import React, {createContext, useState, useEffect} from "react";

export const SnackBarContext = createContext({status: false});

export const SnackBarProvider = (props: any) => {
    const {children} = props;
    const [snackBarInfo, setSnackBarInfo] = useState({status: false});
    const results = {...snackBarInfo, setSnackBarInfo};
    return (
        <SnackBarContext.Provider value={results}>
            {children}
        </SnackBarContext.Provider>
    );
};

